"use client";

import Image from "next/image";
import { Box } from "../Box/Box";
import { ButtonLink } from "../ButtonLink/ButtonLink";
import { Text } from "../Text/Text";

export default function NotFound() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="full"
      width="full"
      padding="10"
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          style={{ gap: 30 }}
        >
          <Text weight="strong">We can&#39;t find this page right now</Text>
          <Image
            src="/images/jetserror.png"
            width={297}
            height={230}
            alt="Error Image"
          />
          <Box>
            <ButtonLink href="/" primary>
              Go Home
            </ButtonLink>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
